"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Dropdown_1 = __importDefault(require("components/design-system/dropdown/Dropdown"));
const Checkbox_1 = __importDefault(require("components/shared/Checkbox"));
const useFilter_1 = __importDefault(require("src/hooks/global-state/useFilter"));
const AdvanceFilter_1 = require("src/components/filter/AdvanceFilter");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const CheckboxMenu = ({ filterKey, options, open, name }) => {
    return (react_1.default.createElement(Dropdown_1.default.MenuItems, { open: open, isParent: false, vPosition: "relative", position: "right" },
        react_1.default.createElement(react_1.default.Fragment, null,
            name && (react_1.default.createElement("div", { className: "px-[16px] pb-[8px] typography-h100 text-n-600" }, name)),
            options.map(option => {
                return (react_1.default.createElement(MenuItem, { key: filterKey + option.value, filterKey: filterKey, option: option }));
            }))));
};
const MenuItem = ({ filterKey, option }) => {
    var _a, _b;
    const { id } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const filter = (0, useFilter_1.default)(state => state.filter);
    const setFilter = (0, useFilter_1.default)(state => state.setFilter);
    const checked = (_b = (_a = filter[id]) === null || _a === void 0 ? void 0 : _a[filterKey]) === null || _b === void 0 ? void 0 : _b.includes(option.value);
    const handleChangeFilter = (key, value) => {
        const newFilter = (0, cloneDeep_1.default)(filter[id]);
        let currentValues = newFilter[key] || [];
        if (currentValues.includes(value)) {
            currentValues = currentValues.filter((arr) => arr !== value);
        }
        else {
            currentValues.push(value);
        }
        newFilter[key] = currentValues;
        setFilter(id, newFilter);
    };
    return (react_1.default.createElement(Dropdown_1.default.MenuItem, { key: filterKey + option.value, customClass: `${checked ? 'bg-base-30024' : ''}` },
        react_1.default.createElement(Checkbox_1.default, { id: filterKey + option.value, name: filterKey + option.value, checked: checked, onClick: () => handleChangeFilter(filterKey, option.value) }, option.label || option.value)));
};
exports.default = CheckboxMenu;
